export { default } from './BottomNavigationAction';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/BottomNavigationAction/index.js
// module id = 787
// module chunks = 121